/** Dossiers groupés du portail partenaire : règles d'affichage partagées par la liste, la page du dossier et la fiche d'une villa. */

/** Les cinq états calculés par le serveur (jamais stockés : ils découlent des villas). */
export const GROUP_STATUS_META = {
  "brouillon": { label: "Brouillon", color: "bg-muted text-muted-foreground border-border" },
  "envoyé": { label: "Envoyé", color: "bg-blue-50 text-blue-700 border-blue-200" },
  "partiellement signé": { label: "Partiellement signé", color: "bg-amber-50 text-amber-700 border-amber-200" },
  "signé": { label: "Signé", color: "bg-emerald-50 text-emerald-700 border-emerald-200" },
  "annulé": { label: "Annulé", color: "bg-rose-50 text-rose-700 border-rose-200" },
};

/** Limite du serveur sur le nom d'un dossier. */
const TITLE_MAX = 120;

/**
 * Pourquoi une proposition ne peut pas rejoindre le dossier en cours de constitution, ou null si elle le peut.
 * `anchorClientId` : client de la première proposition choisie (ou du dossier existant) ; null tant que rien n'est choisi.
 * Le serveur reste l'autorité (langue, devise, CGV, fibre… : 409 avec la liste des fautes) ; ceci n'écarte que l'évident.
 */
export function ungroupableReason(p, anchorClientId) {
  if (p.group_id) return "Déjà dans un dossier";
  if (p.status === "acceptée") return "Déjà signée";
  if (p.status !== "brouillon") return "Déjà envoyée";
  if (!p.client_id) return "Sans client";
  if (anchorClientId && p.client_id !== anchorClientId) return "Autre client";
  return null;
}

/** « <client>, <mois> <année> » (ex. « Caraïbes Villas Management, octobre 2026 »), au plus 120 caractères. */
export function defaultGroupTitle(clientName, now = new Date()) {
  const tail = `, ${now.toLocaleDateString("fr-FR", { month: "long", year: "numeric" })}`;
  const name = (clientName || "").trim() || "Dossier groupé";
  return `${name.slice(0, TITLE_MAX - tail.length).trimEnd()}${tail}`;
}

/** Cumul des montants uniques et mensuels de plusieurs propositions (valeurs absentes = 0). */
export function sumTotals(items) {
  const round2 = (n) => Math.round(n * 100) / 100;
  return items.reduce(
    (t, p) => ({ oneShot: round2(t.oneShot + (Number(p.total_one_shot) || 0)), recurring: round2(t.recurring + (Number(p.total_recurring) || 0)) }),
    { oneShot: 0, recurring: 0 },
  );
}

/** Fautes d'un refus 409 « villas incohérentes » : `[{ key, title, message }]`, vide pour toute autre erreur. */
export function faultsOf(err) {
  const r = err?.response;
  if (r?.status !== 409 || !Array.isArray(r.data?.faults)) return [];
  return r.data.faults.map((f) => ({ key: `${f.proposal_id ?? "*"}:${f.code}`, title: f.title ?? null, message: f.message }));
}
